import { render, staticRenderFns } from "./OpportunitiesList.vue?vue&type=template&id=491e2e15&lang=pug"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
